// extracted by mini-css-extract-plugin
export default {"productCardGreen":"productCard_productCardGreen__YaKqC","productCardRed":"productCard_productCardRed__nVmQT","productCardYellow":"productCard_productCardYellow__JztuF"};